export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات المراسل"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرف / حساب / بريد إلكتروني / هاتف"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرف / عنوان العملة المشفرة / بريد إلكتروني / هاتف"])}
}